import { render, staticRenderFns } from "./RegistrationCode.vue?vue&type=template&id=4c3b68f3"
import script from "./RegistrationCode.vue?vue&type=script&lang=js"
export * from "./RegistrationCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports